import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useSite } from "@/lib/site";
import Logo from "./Logo";

/**
 * 頁尾。
 * SEO 上這裡很重要：它是全站每一頁都有的內部連結網絡，
 * 讓爬蟲能從任何一頁到達重要頁面。連結文字要用真正的關鍵字，不要寫「這裡」。
 */
export default function Footer() {
  const { t } = useI18n();
  const { market, path } = useSite();

  const columns = [
    {
      title: t("footer.forClients"),
      links: [
        { to: "/post-job", label: t("nav.postJob") },
        { to: "/talent", label: t("footer.talentMarketplace") },
        { to: "/how-it-works", label: t("footer.howToHire") },
        { to: "/membership", label: t("footer.membership") },
      ],
    },
    {
      title: t("footer.forFreelancers"),
      links: [
        { to: "/jobs", label: t("nav.findWork") },
        { to: "/signup", label: t("footer.howToFindWork") },
        { to: "/categories", label: t("footer.projectCatalog") },
        { to: "/pricing", label: t("footer.directContracts") },
      ],
    },
    {
      title: t("footer.company"),
      links: [
        { to: "/how-it-works", label: t("footer.about") },
        { to: "/pricing", label: t("footer.careers") },
        { to: "/categories", label: t("footer.press") },
      ],
    },
    {
      title: t("footer.legal"),
      links: [
        { to: "/terms", label: t("footer.terms") },
        { to: "/privacy", label: t("footer.privacy") },
        { to: "/cookies", label: t("footer.cookies") },
      ],
    },
  ];

  return (
    <footer className="bg-surface-2">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink-muted">
              {t("brand.tagline")}
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-pill nm-inset-sm px-3.5 py-1.5 text-xs text-ink-muted">
              {t("footer.currentMarket")}
            </p>
          </div>

          {columns.map((column) => (
            <nav key={column.title} aria-label={column.title}>
              <h2 className="text-sm font-semibold text-ink">{column.title}</h2>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link, index) => (
                  <li key={`${link.to}-${index}`}>
                    <Link
                      to={path(link.to)}
                      className="text-sm text-ink-muted transition-colors hover:text-brand-600 dark:hover:text-brand-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 pt-8 text-xs text-ink-muted sm:flex-row sm:items-center sm:justify-between">
          <p>{t("footer.rights", { year: new Date().getFullYear() })}</p>
          <p>
            {market.paymentProvider === "ecpay"
              ? t("footer.payments.ecpay")
              : "Payments processed by PayPal"}
          </p>
        </div>
      </div>
    </footer>
  );
}
